const STORAGE_KEY = 'toptechCompareTools';
const FILTERS_COLLAPSED_STORAGE_KEY = 'toptechDirectoryFiltersCollapsed';

function directory() {
    document.querySelectorAll('.toptech-archive-modal').forEach((archiveModal) => {
        const modalHash = `#${archiveModal.id}`;
        const openArchiveModal = () => {
            if (archiveModal.open) return;
            if (typeof archiveModal.showModal === 'function') {
                archiveModal.showModal();
            } else {
                archiveModal.setAttribute('open', '');
            }
        };
        const closeArchiveModal = () => {
            if (typeof archiveModal.close === 'function') {
                archiveModal.close();
            } else {
                archiveModal.removeAttribute('open');
            }
            clearArchiveModalHash();
        };
        const clearArchiveModalHash = () => {
            if (window.location.hash !== modalHash) return;
            window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
        };

        document.querySelectorAll(`[data-toptech-archive-modal-open="${archiveModal.id}"]`).forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                event.preventDefault();
                window.history.pushState(null, '', trigger.href);
                openArchiveModal();
            });
        });
        archiveModal.querySelectorAll('[data-toptech-archive-modal-close]').forEach((button) => {
            button.addEventListener('click', closeArchiveModal);
        });
        archiveModal.addEventListener('click', (event) => {
            if (event.target === archiveModal) closeArchiveModal();
        });
        archiveModal.addEventListener('close', clearArchiveModalHash);
        window.addEventListener('hashchange', () => {
            if (window.location.hash === modalHash) openArchiveModal();
        });
        if (window.location.hash === modalHash) openArchiveModal();
    });

    const rankingSection = document.querySelector('.toptech-ranking-table-section');
    const rankingTableBody = rankingSection?.querySelector('.toptech-ranking-table tbody');
    const rankingLoadMore = rankingSection?.querySelector('[data-toptech-ranking-load-more]');
    if (rankingSection && rankingTableBody && rankingLoadMore) {
        const loadMoreButton = rankingLoadMore.querySelector('.toptech-ranking-load-more-button');
        const loadMoreStatus = rankingLoadMore.querySelector('.toptech-ranking-load-more-status');
        const loadMoreSentinel = rankingLoadMore.querySelector('.toptech-ranking-load-more-sentinel');
        let nextUrl = rankingLoadMore.dataset.nextUrl || '';
        let loadedCount = Number(rankingLoadMore.dataset.loaded) || rankingTableBody.rows.length;
        const totalCount = Number(rankingLoadMore.dataset.total) || loadedCount;
        let loading = false;
        let observer = null;

        const updateLoadingStatus = (message) => {
            if (loadMoreStatus) loadMoreStatus.textContent = message;
        };
        const finishRankingLoad = () => {
            nextUrl = '';
            rankingLoadMore.classList.add('is-complete');
            if (observer && loadMoreSentinel) observer.unobserve(loadMoreSentinel);
            updateLoadingStatus(`All ${totalCount} ranked tools are shown`);
        };
        const loadNextRankingPage = () => {
            if (loading || !nextUrl) return;
            loading = true;
            rankingLoadMore.classList.add('is-loading');
            rankingLoadMore.classList.remove('has-load-error');
            if (loadMoreButton) loadMoreButton.disabled = true;
            updateLoadingStatus(`Loading more ranked tools… ${loadedCount} of ${totalCount} shown`);

            window.fetch(nextUrl, {credentials: 'same-origin'}).then((response) => {
                if (!response.ok) throw new Error('Could not load more rankings.');
                return response.text();
            }).then((html) => {
                const nextDocument = new window.DOMParser().parseFromString(html, 'text/html');
                const nextRows = Array.from(nextDocument.querySelectorAll('.toptech-ranking-table tbody tr'));
                const nextLoader = nextDocument.querySelector('[data-toptech-ranking-load-more]');
                if (!nextRows.length) {
                    finishRankingLoad();
                    return;
                }

                nextRows.forEach((row) => {
                    const importedRow = document.importNode(row, true);
                    importedRow.classList.add('is-newly-loaded');
                    rankingTableBody.appendChild(importedRow);
                });
                loadedCount += nextRows.length;
                nextUrl = nextLoader?.dataset.nextUrl || '';
                updateLoadingStatus(`Showing ${Math.min(loadedCount, totalCount)} of ${totalCount} ranked tools`);
                if (!nextUrl || loadedCount >= totalCount) finishRankingLoad();
            }).catch(() => {
                rankingLoadMore.classList.add('has-load-error');
                updateLoadingStatus('Automatic loading paused. Use the button to try again.');
            }).finally(() => {
                loading = false;
                rankingLoadMore.classList.remove('is-loading');
                if (loadMoreButton && nextUrl) loadMoreButton.disabled = false;
            });
        };

        rankingSection.classList.add('is-infinite-ranking');
        loadMoreButton?.addEventListener('click', loadNextRankingPage);
        if ('IntersectionObserver' in window && loadMoreSentinel) {
            rankingLoadMore.classList.add('is-auto-load-enabled');
            observer = new window.IntersectionObserver((entries) => {
                if (entries.some((entry) => entry.isIntersecting)) loadNextRankingPage();
            }, {rootMargin: '700px 0px'});
            observer.observe(loadMoreSentinel);
        }
    }

    if (!window.toptechDirectory) {
        return;
    }

    const config = window.toptechDirectory;

    document.querySelectorAll('input[name="s"], .toptech-search-page input[type="search"]').forEach((input) => {
        if (input.dataset.toptechAutocomplete === 'ready') return;
        input.dataset.toptechAutocomplete = 'ready';
        input.setAttribute('autocomplete', 'off');
        const results = document.createElement('div');
        results.className = 'toptech-search-suggestions';
        results.hidden = true;
        results.setAttribute('role', 'listbox');
        input.insertAdjacentElement('afterend', results);
        let requestNumber = 0;
        const closeSuggestions = () => { results.hidden = true; results.replaceChildren(); };
        input.addEventListener('input', () => {
            const term = input.value.trim();
            const currentRequest = ++requestNumber;
            if (term.length < 2) { closeSuggestions(); return; }
            const url = new URL(config.ajaxUrl, window.location.origin);
            url.searchParams.set('action', config.directorySearchAction);
            url.searchParams.set('nonce', config.nonce);
            url.searchParams.set('q', term);
            window.fetch(url.toString(), {credentials: 'same-origin'}).then((response) => response.json()).then((payload) => {
                if (currentRequest !== requestNumber) return;
                const items = payload?.success ? (payload.data?.items || []) : [];
                results.replaceChildren();
                items.forEach((item) => {
                    const link = document.createElement('a');
                    link.href = item.url;
                    link.setAttribute('role', 'option');
                    const title = document.createElement('strong');
                    title.textContent = item.title;
                    const type = document.createElement('span');
                    type.textContent = item.type;
                    link.append(title, type);
                    results.appendChild(link);
                });
                results.hidden = items.length === 0;
            }).catch(closeSuggestions);
        });
        input.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeSuggestions(); });
        document.addEventListener('click', (event) => { if (!results.contains(event.target) && event.target !== input) closeSuggestions(); });
    });
    const canonicalEventNames = {
        toptech_listing_view: 'tool_page_view',
        toptech_tool_outbound_click: 'tool_outbound_click',
        toptech_compare_open: 'comparison_view',
        toptech_directory_search: 'site_search_submit',
    };
    const capture = (eventName, objectId, metadata = {}) => {
        const payload = {
            object_id: String(objectId || window.location.pathname),
            object_type: 'toptech_directory',
            metadata,
        };

        if (typeof window.gaTrack === 'function') {
            window.gaTrack(eventName, payload);
        }
        if (typeof window.growtypeAnalyticsCapture === 'function') {
            window.growtypeAnalyticsCapture(eventName, {
                object_id: payload.object_id,
                object_type: payload.object_type,
                ...metadata,
            });
        }
        if (typeof window.nsfwlandCapture === 'function' && canonicalEventNames[eventName]) {
            window.nsfwlandCapture(canonicalEventNames[eventName], {
                object_id: payload.object_id,
                object_type: payload.object_type,
                ...metadata,
            });
        }
    };
    let collectionNotificationTimer = null;
    const showCollectionNotification = (message, linkLabel = 'View Favorites') => {
        let notification = document.querySelector('.toptech-collection-notification');
        if (!notification) {
            notification = document.createElement('div');
            notification.className = 'toptech-collection-notification';
            notification.setAttribute('role', 'status');
            notification.setAttribute('aria-live', 'polite');
            notification.setAttribute('aria-atomic', 'true');
            document.body.appendChild(notification);
        }

        window.clearTimeout(collectionNotificationTimer);
        notification.replaceChildren();
        const notificationMessage = document.createElement('span');
        notificationMessage.textContent = message;
        notification.appendChild(notificationMessage);
        if (config.collectionsUrl) {
            const notificationLink = document.createElement('a');
            notificationLink.href = config.collectionsUrl;
            notificationLink.textContent = linkLabel;
            notification.appendChild(notificationLink);
        }
        notification.classList.remove('is-visible');
        window.requestAnimationFrame(() => notification.classList.add('is-visible'));
        collectionNotificationTimer = window.setTimeout(() => {
            notification.classList.remove('is-visible');
        }, 3200);
    };
    document.querySelectorAll('.toptech-delete-listing-form').forEach((form) => {
        form.addEventListener('submit', (event) => {
            if (!window.confirm('Delete this listing? This action moves it to the trash.')) {
                event.preventDefault();
            }
        });
    });
    const parseCompare = () => {
        try {
            const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
            return Array.isArray(parsed) ? parsed.filter((item) => item && item.id).slice(0, 4) : [];
        } catch (error) {
            return [];
        }
    };

    const saveCompare = (items) => window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, 4)));
    const tray = document.querySelector('.toptech-compare-tray');

    const renderCompare = () => {
        const items = parseCompare();
        document.querySelectorAll('.toptech-compare-toggle').forEach((button) => {
            const active = items.some((item) => item.id === Number(button.dataset.toolId));
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
            button.textContent = active ? 'Added' : 'Compare';
        });
        if (!tray) return;
        tray.hidden = items.length === 0;
        tray.querySelector('.toptech-compare-count').textContent = `${items.length}/4`;
        tray.querySelector('.toptech-compare-items').innerHTML = items.map((item) => `<span>${escapeHtml(item.title)}</span>`).join('');
        tray.querySelector('.toptech-compare-open').href = `${config.compareUrl}?tools=${items.map((item) => item.id).join(',')}`;
    };

    const escapeHtml = (value) => {
        const div = document.createElement('div');
        div.textContent = String(value);
        return div.innerHTML;
    };

    const request = (operation, objectId, extra = {}) => {
        const normalizedObjectId = Number(objectId);
        if (!normalizedObjectId || normalizedObjectId < 1 || Math.floor(normalizedObjectId) !== normalizedObjectId) {
            return Promise.reject(new Error('A valid object ID is required.'));
        }

        const body = new URLSearchParams(Object.assign({action: 'toptech_retention_action', nonce: config.nonce, operation, objectId: normalizedObjectId}, extra));
        return window.fetch(config.ajaxUrl, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/x-www-form-urlencoded'}, body}).then((response) => response.json());
    };

    const closeCollectionMenu = (menu, returnFocus = false) => {
        const toggle = menu?.querySelector('.toptech-collection-menu-toggle');
        const panel = menu?.querySelector('.toptech-collection-menu-panel');
        if (!toggle || !panel) return;

        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        menu.classList.remove('is-open');
        if (returnFocus) toggle.focus();
    };

    const closeCollectionMenus = (exceptMenu = null) => {
        document.querySelectorAll('.toptech-collection-menu.is-open').forEach((menu) => {
            if (menu !== exceptMenu) closeCollectionMenu(menu);
        });
    };

    document.addEventListener('click', (event) => {
        const collectionMenuToggle = event.target.closest('.toptech-collection-menu-toggle');
        if (collectionMenuToggle) {
            event.preventDefault();
            const menu = collectionMenuToggle.closest('.toptech-collection-menu');
            const panel = menu?.querySelector('.toptech-collection-menu-panel');
            if (!menu || !panel) return;

            if (!collectionMenuToggle.classList.contains('is-active')) {
                const saveButton = panel.querySelector('.toptech-collection-toggle');
                if (saveButton) saveButton.click();
                return;
            }

            const shouldOpen = panel.hidden;
            closeCollectionMenus(menu);
            panel.hidden = !shouldOpen;
            collectionMenuToggle.setAttribute('aria-expanded', String(shouldOpen));
            menu.classList.toggle('is-open', shouldOpen);
            return;
        }

        const compareButton = event.target.closest('.toptech-compare-toggle');
        if (compareButton) {
            event.preventDefault();
            const id = Number(compareButton.dataset.toolId);
            const items = parseCompare();
            const existingIndex = items.findIndex((item) => item.id === id);
            const compareAction = existingIndex >= 0 ? 'toptech_compare_remove' : 'toptech_compare_add';
            if (existingIndex >= 0) items.splice(existingIndex, 1);
            else if (items.length < 4) items.push({id, title: compareButton.dataset.toolTitle || 'Tool'});
            else {
                window.alert('You can compare up to four tools.');
                return;
            }
            saveCompare(items);
            renderCompare();
            capture(compareAction, id, {compare_count: items.length});
            return;
        }

        const compareOpen = event.target.closest('.toptech-compare-open');
        if (compareOpen) {
            capture('toptech_compare_open', window.location.pathname, {compare_count: parseCompare().length});
            return;
        }

        const outboundToolLink = event.target.closest('a[href]');
        const outboundToolId = Number(outboundToolLink?.dataset.toptechOutboundToolId || config.currentToolId);
        if (outboundToolLink && outboundToolId > 0) {
            try {
                const outboundUrl = new URL(outboundToolLink.href, window.location.origin);
                if (outboundUrl.hostname !== window.location.hostname) {
                    capture('toptech_tool_outbound_click', outboundToolId, {
                        destination_host: outboundUrl.hostname,
                        link_text: (outboundToolLink.textContent || '').trim().substring(0, 100),
                        page_type: document.body.className.includes('page-template') ? 'page' : 'tool_profile',
                        page_path: window.location.pathname,
                        source_id: outboundToolLink.dataset.toptechSourceId || document.body.id || '',
                        cta_position: outboundToolLink.dataset.toptechCtaPosition || (outboundToolLink.closest('header') ? 'header' : (outboundToolLink.closest('footer') ? 'footer' : 'content')),
                        ranking_position: Number(outboundToolLink.dataset.toptechRankingPosition || 0),
                        search_query: new URLSearchParams(window.location.search).get('s') || '',
                        active_filters: ['category', 'pricing', 'platform', 'use_case', 'feature', 'integration', 'orderby'].reduce((filters, key) => {
                            const values = new URLSearchParams(window.location.search).getAll(`${key}[]`).concat(new URLSearchParams(window.location.search).getAll(key));
                            if (values.length) filters[key] = values;
                            return filters;
                        }, {}),
                        placement: outboundToolLink.rel.includes('sponsored') ? 'sponsored' : 'organic',
                    });
                }
            } catch (error) {
                // Ignore malformed third-party URLs without interrupting navigation.
            }
        }

        const clearButton = event.target.closest('.toptech-compare-clear');
        if (clearButton) { saveCompare([]); renderCompare(); return; }

        const collectionButton = event.target.closest('.toptech-collection-toggle');
        if (collectionButton) {
            event.preventDefault();
            if (!config.isLoggedIn) { window.location.href = config.loginUrl; return; }
            collectionButton.disabled = true;
            request('toggle_collection', collectionButton.dataset.toolId).then((result) => {
                if (result.success) {
                    document.querySelectorAll('.toptech-collection-toggle').forEach((button) => {
                        if (button.dataset.toolId !== collectionButton.dataset.toolId) return;
                        button.classList.toggle('is-active', result.data.active);
                        button.setAttribute('aria-pressed', String(result.data.active));
                        button.textContent = result.data.active
                            ? (button.dataset.labelActive || 'Saved')
                            : (button.dataset.labelDefault || 'Save');
                        if (button.dataset.ariaLabelDefault || button.dataset.ariaLabelActive) {
                            button.setAttribute('aria-label', result.data.active
                                ? (button.dataset.ariaLabelActive || 'Remove saved tool')
                                : (button.dataset.ariaLabelDefault || 'Save tool'));
                        }
                    });
                    document.querySelectorAll('.toptech-collection-menu').forEach((menu) => {
                        const menuButton = menu.querySelector('.toptech-collection-toggle');
                        const starToggle = menu.querySelector('.toptech-collection-menu-toggle');
                        if (!menuButton || menuButton.dataset.toolId !== collectionButton.dataset.toolId || !starToggle) return;
                        starToggle.classList.toggle('is-active', result.data.active);
                        starToggle.textContent = result.data.active ? '★' : '☆';
                        starToggle.setAttribute('aria-label', result.data.active ? 'Manage saved tool' : 'Save tool');
                    });
                    if (result.data.active && typeof window.nsfwlandCapture === 'function') {
                        window.nsfwlandCapture('tool_save', {tool_id: Number(collectionButton.dataset.toolId)});
                    }
                    showCollectionNotification(result.data.active ? 'Tool saved.' : 'Tool removed from saved tools.');
                }
            }).finally(() => { collectionButton.disabled = false; });
            return;
        }

        const shareButton = event.target.closest('.toptech-tool-share');
        if (shareButton) {
            event.preventDefault();
            const shareUrl = shareButton.dataset.shareUrl || window.location.href;
            const shareTitle = shareButton.dataset.shareTitle || document.title;
            const copyShareUrl = () => {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    return navigator.clipboard.writeText(shareUrl);
                }
                const copyField = document.createElement('textarea');
                copyField.value = shareUrl;
                copyField.setAttribute('readonly', '');
                copyField.style.position = 'fixed';
                copyField.style.opacity = '0';
                document.body.appendChild(copyField);
                copyField.select();
                const copied = document.execCommand('copy');
                copyField.remove();
                return copied ? Promise.resolve() : Promise.reject(new Error('Copy failed'));
            };
            const shareAction = navigator.share
                ? navigator.share({title: shareTitle, url: shareUrl})
                : copyShareUrl();

            shareButton.disabled = true;
            Promise.resolve(shareAction).then(() => {
                shareButton.textContent = navigator.share ? 'Shared' : 'Link copied';
                if (typeof window.nsfwlandCapture === 'function') {
                    window.nsfwlandCapture('share', {
                        tool_id: Number(shareButton.dataset.toolId || config.currentToolId || 0),
                        method: navigator.share ? 'native' : 'copy',
                    });
                }
                window.setTimeout(() => {
                    shareButton.textContent = shareButton.dataset.defaultLabel || 'Share';
                }, 1800);
            }).catch(() => {}).finally(() => { shareButton.disabled = false; });
            return;
        }

        const recommendButton = event.target.closest('.toptech-recommend-toggle');
        if (recommendButton) {
            event.preventDefault();
            if (!config.isLoggedIn) { window.location.href = config.loginUrl; return; }
            recommendButton.disabled = true;
            request('toggle_recommendation', recommendButton.dataset.toolId).then((result) => {
                if (!result.success) return;
                recommendButton.classList.toggle('is-active', result.data.active);
                recommendButton.setAttribute('aria-pressed', String(result.data.active));
                const label = recommendButton.querySelector('[data-recommend-label]');
                const count = recommendButton.querySelector('[data-recommend-count]');
                if (label) label.textContent = result.data.active
                    ? (recommendButton.dataset.labelActive || 'Recommended')
                    : (recommendButton.dataset.labelDefault || 'Recommend');
                if (count) count.textContent = result.data.count;
            }).finally(() => { recommendButton.disabled = false; });
            return;
        }

        const followButton = event.target.closest('.toptech-follow-toggle');
        if (followButton) {
            event.preventDefault();
            if (!config.isLoggedIn) { window.location.href = config.loginUrl; return; }
            followButton.disabled = true;
            request('follow_category', followButton.dataset.termId).then((result) => {
                if (result.success) {
                    followButton.classList.toggle('is-active', result.data.active);
                    followButton.setAttribute('aria-pressed', String(result.data.active));
                    const label = result.data.active ? 'Following category' : 'Follow category';
                    const icon = followButton.querySelector('.toptech-follow-toggle-icon');
                    const labelElement = followButton.querySelector('.toptech-follow-toggle-label');
                    if (icon) icon.textContent = result.data.active ? '★' : '☆';
                    if (labelElement) labelElement.textContent = label;
                    followButton.setAttribute('aria-label', label);
                }
            }).finally(() => { followButton.disabled = false; });
            return;
        }

        const reportButton = event.target.closest('.toptech-report-link');
        if (reportButton) {
            event.preventDefault();
            const status = reportButton.closest('.toptech-report-actions')?.querySelector('.toptech-report-status');
            reportButton.disabled = true;
            const body = new URLSearchParams({action: 'toptech_report_broken_link', nonce: config.nonce, postId: reportButton.dataset.toolId});
            window.fetch(config.ajaxUrl, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/x-www-form-urlencoded'}, body}).then((response) => response.json()).then((result) => {
                if (!result.success) throw new Error(result.data && result.data.message ? result.data.message : 'Could not submit the report.');
                reportButton.textContent = 'Link reported';
                if (status) status.textContent = result.data && result.data.message ? result.data.message : 'Report submitted.';
            }).catch((error) => {
                reportButton.disabled = false;
                if (status) status.textContent = error.message || 'Could not submit the report.';
            });
            return;
        }

        const claimButton = event.target.closest('.toptech-claim-listing');
        if (claimButton) {
            event.preventDefault();
            if (!config.isLoggedIn) { window.location.href = config.loginUrl; return; }
            const status = claimButton.closest('.toptech-report-actions')?.querySelector('.toptech-report-status');
            claimButton.disabled = true;
            const body = new URLSearchParams({action: 'toptech_claim_listing', nonce: config.nonce, postId: claimButton.dataset.toolId});
            window.fetch(config.ajaxUrl, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/x-www-form-urlencoded'}, body}).then((response) => response.json()).then((result) => {
                if (!result.success) throw new Error(result.data && result.data.message ? result.data.message : 'Could not submit the claim.');
                claimButton.textContent = 'Claim request pending';
                if (status) status.textContent = result.data && result.data.message ? result.data.message : 'Claim submitted.';
                if (typeof window.nsfwlandCapture === 'function') {
                    window.nsfwlandCapture('vendor_claim', {tool_id: Number(claimButton.dataset.toolId)});
                }
            }).catch((error) => {
                claimButton.disabled = false;
                if (status) status.textContent = error.message || 'Could not submit the claim.';
            });
        }
    });

    document.addEventListener('click', (event) => {
        document.querySelectorAll('.toptech-collection-menu.is-open').forEach((menu) => {
            if (!menu.contains(event.target)) closeCollectionMenu(menu);
        });
    });

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const openMenu = document.querySelector('.toptech-collection-menu.is-open');
        if (openMenu) closeCollectionMenu(openMenu, true);
    });

    const saveSelectedCollection = (select) => {
        if (!select || !select.value) return;
        select.disabled = true;
        request('save_to_named_collection', select.dataset.toolId, {collection: select.value}).then((result) => {
            if (result.success) {
                const savedOption = select.options[select.selectedIndex];
                savedOption.textContent = `${result.data.collection} ✓`;
                if (result.data.added && typeof window.nsfwlandCapture === 'function') {
                    window.nsfwlandCapture('collection_add', {
                        tool_id: Number(select.dataset.toolId),
                        collection_type: 'named',
                    });
                }
                showCollectionNotification(`Added to ${result.data.collection}.`, 'View collection');
            }
        }).finally(() => {
            select.disabled = false;
            select.value = '';
            if (window.jQuery && window.jQuery(select).data('chosen')) {
                window.jQuery(select).trigger('chosen:updated');
            }
        });
    };

    document.addEventListener('change', (event) => {
        const select = event.target.closest('.toptech-collection-select');
        saveSelectedCollection(select);
    });

    if (window.jQuery) {
        window.jQuery(document)
            .off('change.toptechCollectionSelect', '.toptech-collection-select')
            .on('change.toptechCollectionSelect', '.toptech-collection-select', function (event) {
                if (event.originalEvent) return;
                saveSelectedCollection(this);
            });
    }

    const collectionForm = document.querySelector('.toptech-create-collection');
    if (collectionForm) {
        collectionForm.addEventListener('submit', (event) => {
            event.preventDefault();
            const input = collectionForm.querySelector('[name="collection_name"]');
            const status = collectionForm.querySelector('.toptech-form-status');
            const body = new URLSearchParams({action: 'toptech_create_collection', nonce: config.nonce, name: input.value});
            window.fetch(config.ajaxUrl, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/x-www-form-urlencoded'}, body}).then((response) => response.json()).then((result) => {
                status.textContent = result.success ? 'Collection created. Reloading…' : (result.data && result.data.message ? result.data.message : 'Could not create collection.');
                if (result.success) {
                    if (result.data.created && typeof window.nsfwlandCapture === 'function') {
                        window.nsfwlandCapture('collection_create', {collection_type: 'named'});
                    }
                    window.location.reload();
                }
            });
        });
    }

    const collectionsWorkspace = document.querySelector('.toptech-collections-workspace');
    if (collectionsWorkspace) {
        const collectionsStatus = collectionsWorkspace.querySelector('.toptech-collections-status');
        const setRenameState = (section, editing) => {
            if (!section) return;
            const title = section.querySelector('[data-collection-title]');
            const form = section.querySelector('.toptech-rename-collection-form');
            const toggle = section.querySelector('.toptech-rename-collection-toggle');
            const input = form?.querySelector('[name="collection_name"]');
            if (!title || !form || !toggle || !input) return;

            title.hidden = editing;
            form.hidden = !editing;
            toggle.hidden = editing;
            toggle.setAttribute('aria-expanded', String(editing));
            if (editing) {
                input.value = title.textContent.trim();
                input.focus();
                input.select();
            } else {
                toggle.focus();
            }
        };
        const moveCollectionItem = (select) => {
            const targetCollection = select?.value || '';
            const sourceCollection = select?.dataset.sourceCollection || '';
            const toolId = Number(select?.dataset.toolId || 0);
            if (!select || !targetCollection || !sourceCollection || !toolId || select.dataset.moving === 'true') return;

            select.dataset.moving = 'true';
            select.disabled = true;
            if (window.jQuery && window.jQuery(select).data('chosen')) window.jQuery(select).trigger('chosen:updated');

            const body = new URLSearchParams({
                action: 'toptech_move_collection_item',
                nonce: config.nonce,
                toolId: String(toolId),
                sourceCollection,
                targetCollection,
            });

            window.fetch(config.ajaxUrl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                body,
            }).then((response) => response.json()).then((result) => {
                if (!result.success) throw new Error(result.data && result.data.message ? result.data.message : 'Could not move this tool.');

                const item = select.closest('.toptech-collection-item');
                const sourceSection = item?.closest('.toptech-saved-collection');
                const targetSection = Array.from(collectionsWorkspace.querySelectorAll('.toptech-saved-collection'))
                    .find((section) => section.dataset.collection === targetCollection);
                if (!item || !sourceSection || !targetSection) {
                    window.location.reload();
                    return;
                }

                let targetGrid = targetSection.querySelector('.toptech-collection-grid');
                if (!targetGrid) {
                    const tableWrap = document.createElement('div');
                    tableWrap.className = 'toptech-collection-table-wrap';
                    tableWrap.innerHTML = '<table class="toptech-collection-table"><thead><tr><th scope="col">Tool</th><th scope="col">Rating</th><th scope="col">Move to collection</th></tr></thead><tbody class="toptech-collection-grid"></tbody></table>';
                    targetSection.querySelector('.toptech-collection-empty')?.remove();
                    targetSection.appendChild(tableWrap);
                    targetGrid = tableWrap.querySelector('.toptech-collection-grid');
                }

                const sourceName = sourceSection.querySelector('h2')?.textContent?.trim() || sourceCollection;
                const sourceGrid = item.closest('.toptech-collection-grid');
                targetGrid.prepend(item);
                select.dataset.sourceCollection = targetCollection;
                Array.from(select.options).forEach((option) => {
                    if (option.value === targetCollection) option.remove();
                });
                const sourceOption = document.createElement('option');
                sourceOption.value = sourceCollection;
                sourceOption.textContent = sourceName;
                select.appendChild(sourceOption);
                select.value = '';

                if (sourceGrid && !sourceGrid.querySelector('.toptech-collection-item')) {
                    sourceGrid.closest('.toptech-collection-table-wrap')?.remove();
                    const emptyMessage = document.createElement('p');
                    emptyMessage.className = 'toptech-collection-empty';
                    emptyMessage.textContent = 'No tools here yet.';
                    sourceSection.appendChild(emptyMessage);
                }

                if (collectionsStatus) collectionsStatus.textContent = result.data.message || 'Tool moved.';
                showCollectionNotification(result.data.message || 'Tool moved.', 'View collections');
            }).catch((error) => {
                select.value = '';
                if (collectionsStatus) collectionsStatus.textContent = error.message || 'Could not move this tool.';
            }).finally(() => {
                select.disabled = false;
                delete select.dataset.moving;
                if (window.jQuery && window.jQuery(select).data('chosen')) window.jQuery(select).trigger('chosen:updated');
            });
        };

        collectionsWorkspace.addEventListener('change', (event) => {
            const select = event.target.closest('.toptech-move-collection');
            if (select) moveCollectionItem(select);
        });

        if (window.jQuery) {
            window.jQuery(document)
                .off('change.toptechMoveCollection', '.toptech-move-collection')
                .on('change.toptechMoveCollection', '.toptech-move-collection', function (event) {
                    if (event.originalEvent) return;
                    moveCollectionItem(this);
                });
        }

        collectionsWorkspace.addEventListener('click', (event) => {
            const renameButton = event.target.closest('.toptech-rename-collection-toggle');
            if (renameButton) {
                setRenameState(renameButton.closest('.toptech-saved-collection'), true);
                return;
            }

            const cancelButton = event.target.closest('.toptech-rename-collection-cancel');
            if (cancelButton) {
                setRenameState(cancelButton.closest('.toptech-saved-collection'), false);
                return;
            }

            const deleteButton = event.target.closest('.toptech-delete-collection');
            if (!deleteButton) return;

            const collection = deleteButton.dataset.collection || '';
            const collectionName = deleteButton.dataset.collectionName || 'this collection';
            if (!collection || !window.confirm(`Delete “${collectionName}”? Saved tools will not be deleted.`)) return;

            deleteButton.disabled = true;
            deleteButton.textContent = 'Deleting…';
            const body = new URLSearchParams({action: 'toptech_delete_collection', nonce: config.nonce, collection});

            window.fetch(config.ajaxUrl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                body,
            }).then((response) => response.json()).then((result) => {
                if (!result.success) {
                    throw new Error(result.data && result.data.message ? result.data.message : 'Could not delete collection.');
                }

                deleteButton.closest('.toptech-saved-collection')?.remove();
                if (collectionsStatus) collectionsStatus.textContent = result.data.message || 'Collection deleted.';
            }).catch((error) => {
                deleteButton.disabled = false;
                deleteButton.textContent = 'Delete';
                if (collectionsStatus) collectionsStatus.textContent = error.message || 'Could not delete collection.';
            });
        });

        collectionsWorkspace.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape' || !event.target.closest('.toptech-rename-collection-form')) return;
            setRenameState(event.target.closest('.toptech-saved-collection'), false);
        });

        collectionsWorkspace.addEventListener('submit', (event) => {
            const form = event.target.closest('.toptech-rename-collection-form');
            if (!form) return;
            event.preventDefault();

            const section = form.closest('.toptech-saved-collection');
            const input = form.querySelector('[name="collection_name"]');
            const saveButton = form.querySelector('.toptech-rename-collection-save');
            const collection = form.dataset.collection || '';
            const name = input?.value.trim() || '';
            if (!section || !input || !saveButton || !collection || !name || form.dataset.saving === 'true') return;

            form.dataset.saving = 'true';
            input.disabled = true;
            saveButton.disabled = true;
            saveButton.textContent = 'Saving…';
            const body = new URLSearchParams({action: 'toptech_rename_collection', nonce: config.nonce, collection, name});

            window.fetch(config.ajaxUrl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                body,
            }).then((response) => response.json()).then((result) => {
                if (!result.success) {
                    throw new Error(result.data && result.data.message ? result.data.message : 'Could not rename collection.');
                }

                const savedName = result.data.name;
                const title = section.querySelector('[data-collection-title]');
                const label = form.querySelector('label');
                const renameButton = section.querySelector('.toptech-rename-collection-toggle');
                const deleteButton = section.querySelector('.toptech-delete-collection');
                title.textContent = savedName;
                input.value = savedName;
                label.textContent = `New name for ${savedName}`;
                renameButton.setAttribute('aria-label', `Rename ${savedName} collection`);
                if (deleteButton) {
                    deleteButton.dataset.collectionName = savedName;
                    deleteButton.setAttribute('aria-label', `Delete ${savedName} collection`);
                }
                collectionsWorkspace.querySelectorAll('.toptech-move-collection').forEach((select) => {
                    Array.from(select.options).forEach((option) => {
                        if (option.value === collection) option.textContent = savedName;
                    });
                    if (window.jQuery && window.jQuery(select).data('chosen')) window.jQuery(select).trigger('chosen:updated');
                });
                if (collectionsStatus) collectionsStatus.textContent = result.data.message || 'Collection renamed.';
                setRenameState(section, false);
            }).catch((error) => {
                if (collectionsStatus) collectionsStatus.textContent = error.message || 'Could not rename collection.';
            }).finally(() => {
                input.disabled = false;
                saveButton.disabled = false;
                saveButton.textContent = 'Save';
                delete form.dataset.saving;
                if (!form.hidden) input.focus();
            });
        });
    }

    const filterToggle = document.querySelector('.toptech-filter-toggle');
    if (filterToggle) {
        const form = filterToggle.closest('.toptech-directory-filters');
        const toggleLabel = filterToggle.querySelector('[data-filter-toggle-label]');
        let filtersCollapsed = window.matchMedia('(max-width: 900px)').matches;

        try {
            const savedState = window.localStorage.getItem(FILTERS_COLLAPSED_STORAGE_KEY);
            if (savedState !== null) {
                filtersCollapsed = savedState === 'true';
            }
        } catch (error) {
            // Keep the responsive default when browser storage is unavailable.
        }

        const renderFilterToggle = () => {
            form.classList.toggle('is-collapsed', filtersCollapsed);
            filterToggle.setAttribute('aria-expanded', String(!filtersCollapsed));
            if (toggleLabel) {
                toggleLabel.textContent = filtersCollapsed ? 'Show filters' : 'Hide filters';
            }
        };

        renderFilterToggle();

        filterToggle.addEventListener('click', () => {
            filtersCollapsed = !filtersCollapsed;
            renderFilterToggle();
            try {
                window.localStorage.setItem(FILTERS_COLLAPSED_STORAGE_KEY, String(filtersCollapsed));
            } catch (error) {
                // The toggle still works for this page when storage is unavailable.
            }
        });
    }

    const digestToggle = document.querySelector('.toptech-digest-toggle');
    if (digestToggle) {
        const digestForm = digestToggle.closest('.toptech-digest-preferences');
        const topicFieldset = digestForm?.querySelector('.toptech-digest-topics');
        const status = digestForm?.querySelector('.toptech-digest-status');
        const topicInputs = Array.from(digestForm?.querySelectorAll('input[name="toptech_email_subscription"]') || []);
        const newsTopicInputs = Array.from(digestForm?.querySelectorAll('input[name="toptech_news_topic"]') || []);
        const newsToggle = topicInputs.find((input) => input.value === 'news');
        let previousEnabled = digestToggle.checked;
        const syncDigestControls = () => {
            if (topicFieldset) topicFieldset.disabled = !digestToggle.checked;
            topicInputs.forEach((input) => { input.disabled = !digestToggle.checked; });
            newsTopicInputs.forEach((input) => { input.disabled = !digestToggle.checked || !newsToggle?.checked; });
        };
        const saveDigest = () => {
            digestToggle.disabled = true;
            topicInputs.forEach((input) => { input.disabled = true; });
            newsTopicInputs.forEach((input) => { input.disabled = true; });
            const selected = topicInputs.filter((input) => input.checked).map((input) => input.value);
            const selectedNewsTopics = newsTopicInputs.filter((input) => input.checked).map((input) => input.value);
            const body = new URLSearchParams({action: 'toptech_digest_preference', nonce: config.nonce, enabled: digestToggle.checked ? '1' : '0', subscriptions: selected.join(','), news_topics: selectedNewsTopics.join(','), source: 'digest_dashboard'});
            window.fetch(config.ajaxUrl, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/x-www-form-urlencoded'}, body}).then((response) => response.json()).then((result) => {
                if (!result.success) throw new Error(result.data?.message || 'Could not save email preferences.');
                if (status) status.textContent = digestToggle.checked ? 'Newsletter preferences saved.' : 'Weekly newsletter turned off.';
                if (typeof window.nsfwlandCapture === 'function') {
                    if (digestToggle.checked && !previousEnabled) {
                        window.nsfwlandCapture('newsletter_signup', {placement: 'personal_digest', subscriptions: selected});
                    }
                    window.nsfwlandCapture('newsletter_preference_change', {enabled: digestToggle.checked, subscriptions: selected, newsTopics: selectedNewsTopics});
                }
                previousEnabled = digestToggle.checked;
            }).catch((error) => {
                if (status) status.textContent = error.message || 'Could not save email preferences.';
            }).finally(() => {
                digestToggle.disabled = false;
                syncDigestControls();
            });
        };
        digestToggle.addEventListener('change', saveDigest);
        topicInputs.forEach((input) => input.addEventListener('change', saveDigest));
        newsTopicInputs.forEach((input) => input.addEventListener('change', saveDigest));
        syncDigestControls();
    }

    const currentToolId = Number(config.currentToolId);
    if (currentToolId > 0) {
        capture('toptech_listing_view', currentToolId, {path: window.location.pathname});
    }
    if (currentToolId > 0 && config.isLoggedIn) {
        request('record_view', currentToolId).catch(() => {});
    }

    document.querySelectorAll('.growtype-search-form').forEach((form) => {
        form.addEventListener('submit', () => {
            const input = form.querySelector('input[name="s"]');
            const query = input ? input.value.trim() : '';
            if (!query) return;

            capture('toptech_directory_search', window.location.pathname, {
                search_term: query.substring(0, 100),
                result_context: document.body.classList.contains('tax-tool_tax') ? 'category' : 'directory',
            });
        });
    });

    renderCompare();
}

export {directory};
